import { useState, useContext } from "react";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import { Form, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import { UserDataContext } from "../components/UserDataContext";
import { registerLocale } from "react-datepicker";
import { addDays, isAfter } from "date-fns";
import { format } from "date-fns";
import "../components/button.css";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { pl } from "date-fns/locale";
import { marginBottom } from "../App";
import Alerts from "../components/Alerts";
import Button from "@mui/material/Button";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { apiRequest } from "../components/Config";

const validationSchema = Yup.object().shape({
  user: Yup.string().required("Użytkownik jest wymagany"),
  fullName: Yup.string().required("Imię i nazwisko są wymagane"),
  city: Yup.string().required("Miejscowość jest wymagana"),
  email: Yup.string()
    .email("Nieprawidłowy adres email")
    .required("Email jest wymagany"),
  selectedDate: Yup.date()
    .nullable()
    .required("Data jest wymagana")
    .test(
      "is-after-today",
      "Data musi być późniejsza niż dzisiaj",
      (value) => value && isAfter(value, new Date())
    ),
});

export default function AddUser({ perm, refreshData }) {
  registerLocale("pl", pl);

  const { userData } = useContext(UserDataContext);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);

  const initialValues = {
    user: "",
    fullName: "",
    city: "",
    email: "",
    phone: "",
    selectedDate: new Date(new Date().getFullYear(), 11, 31),
    expire: "",
    permId: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const formatted = format(values.selectedDate, "yyyy-MM-dd");
    values["idgrp"] = userData.idGrp;
    values["expire"] = formatted;
    values["permId"] = perm;

    try {
      const response = await apiRequest("register", "POST", values);

      if (response.error_msg === 200) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Sukces",
          severity: "success",
          info: "Użytkownik dodany!",
        });
        refreshData();
      }
      if (response.error_msg === 500) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Coś poszło nie tak podczas rejestracji. Prawdopodobnie nie zostały wybrane uprawnienia użytkownika. Spróbuj ponownie lub skontaktuj się z autorem.",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 501) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Takie konto już istnieje w systemie!",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <h4>Rejestracja konta Wykonawcy</h4>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue, values }) => (
          <FormikForm>
            <Row style={{ marginBottom }} className="align-items-center">
              <Col md="2" style={{ marginBottom }}>
                <ThemeProvider theme={theme}>
                  <Form.Group controlId="formUser">
                    <Field
                      as={TextField}
                      label="Konto logowania"
                      variant="outlined"
                      name="user"
                      autoComplete="off"
                      fullWidth
                    />
                    <ErrorMessage
                      name="user"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </ThemeProvider>
              </Col>
              <Col md="2" style={{ marginBottom }}>
                <ThemeProvider theme={theme}>
                  <Form.Group controlId="formFullName">
                    <Field
                      as={TextField}
                      label="Nazwisko i Imię Wykonawcy"
                      type="text"
                      name="fullName"
                      fullWidth
                    />
                    <ErrorMessage
                      name="fullName"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </ThemeProvider>
              </Col>
              <Col md="2" style={{ marginBottom }}>
                <ThemeProvider theme={theme}>
                  <Form.Group controlId="formCity">
                    <Field
                      as={TextField}
                      label="Miasto zamieszkania Wykonawcy"
                      type="text"
                      name="city"
                      fullWidth
                    />
                    <ErrorMessage
                      name="city"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </ThemeProvider>
              </Col>
              <Col md="2" style={{ marginBottom }}>
                <ThemeProvider theme={theme}>
                  <Form.Group controlId="formEmail">
                    <Field
                      as={TextField}
                      label="Email"
                      type="email"
                      name="email"
                      fullWidth
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </ThemeProvider>
              </Col>
              <Col md="2" style={{ marginBottom }}>
                <ThemeProvider theme={theme}>
                  <Form.Group controlId="formPhone">
                    <Field
                      as={TextField}
                      label="Telefon"
                      type="text"
                      name="phone"
                      fullWidth
                    />
                    <ErrorMessage
                      name="phone"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </ThemeProvider>
              </Col>
              {/*
              <Col md="2" style={{ marginBottom }}>
                <ThemeProvider theme={theme}>
                  <Box sx={{ minWidth: 120 }}>
                    <Form.Group controlId="formPermission">
                      <Select
                        id="permissions"
                        name="permId"
                        value={userPermission}
                        label="Uprawnienia"
                        onChange={handleChange}
                        fullWidth
                      >
                        <MenuItem value="">
                          <em>Wybierz uprawnienia</em>
                        </MenuItem>
                        {permissionsAll.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.description}
                          </MenuItem>
                        ))}
                      </Select>
                    </Form.Group>
                  </Box>
                </ThemeProvider>
              </Col>
              */}
              <Col md="2" style={{ marginBottom }}>
                <ThemeProvider theme={theme}>
                  <Form.Group controlId="formDate">
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={pl}
                    >
                      <DatePicker
                        label="Wybierz datę ważności konta"
                        value={values.selectedDate}
                        selected={values.selectedDate}
                        onChange={(date) => setFieldValue("selectedDate", date)}
                        minDate={addDays(new Date(), 1)}
                        dateFormat="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        slotProps={{ textField: { variant: "outlined" } }}
                      />
                    </LocalizationProvider>
                    <ErrorMessage
                      name="selectedDate"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </ThemeProvider>
              </Col>
            </Row>
            <Row>
              <Col>
                <ThemeProvider theme={theme}>
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Rejestruj
                  </Button>
                </ThemeProvider>
              </Col>
            </Row>

            <hr></hr>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
}
